import { Injectable, Injector, ComponentFactoryResolver } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalStack } from '@ng-bootstrap/ng-bootstrap/modal/modal-stack';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap/modal/modal';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class SNModalService extends NgbModal {
	readonly snModalConfig: NgbModalOptions = {
		windowClass: 'ng-bootstrap-modal',
		backdropClass: 'ng-bootstrap-backdrop',
		backdrop: 'static',
		keyboard: false
	};
	modalData: Subject<any> = new Subject<any>();

	constructor(
		private componentFactoryResolver: ComponentFactoryResolver,
		private injector: Injector,
		private modalStack: NgbModalStack
	) {
		super(componentFactoryResolver, injector, modalStack);
	}

	openModal(content: any): NgbModalRef {
		return super.open(content, this.snModalConfig);
	}

	setModalData(data: any) {
		this.modalData.next(data);
	}

	getModalData() {
		return this.modalData.asObservable();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/services/modal/snModal.service.ts